export { SkyAvatarComponent } from './avatar.component';
export { SkyAvatarInnerComponent } from './avatar.inner.component';
export { SkyAvatarModule } from './avatar.module';
export { SkyAvatarSrc } from './avatar-src';
